export default __webpack_public_path__ + "static/media/logo.125ba452.png";